import React from "react";
import { Card, Text, Title, Button, Group, Stack } from "@mantine/core";
import { IntegrationResponse } from "types/responses.type";
import integrationService from "services/integration.service";

interface IntegrationCardProps {
  integration: IntegrationResponse;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({ integration }) => {
  const handleDisconnect = () => {
    integrationService.disconnect(integration.name);
  };
  const handleOptions = () => {
    window.location.href =
      "/settings/integrations/" + integration.name + "/options";
  };

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Group justify="space-between" align="flex-end" wrap="nowrap">
        <Group wrap="nowrap" align="start">
          <div>
            <Card
              shadow="sm"
              padding="lg"
              radius="md"
              w={64}
              h={64}
              withBorder
            />
          </div>
          <div>
            <Text c="dimmed" size="xs">
              {integration.category}
            </Text>
            <Title order={3}>{integration.displayName}</Title>
            <Text c="dimmed" size="sm" mt="xs">
              {integration.description}
            </Text>
          </div>
        </Group>
        <Stack>
          <Button
            variant="outline"
            color="green"
            size="xs"
            onClick={handleOptions}
          >
            Options
          </Button>
          <Button
            variant="outline"
            color="red"
            size="xs"
            onClick={handleDisconnect}
          >
            Disconnect
          </Button>
        </Stack>
      </Group>
    </Card>
  );
};

export default IntegrationCard;
